module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Bold.db4799c2f1a178b6663b1d5d56e7787b.woff";